import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Form } from 'react-final-form';
import { Content } from '../../infrastructure/content';

const InformativePage = ({ onContinue }) => (
  <Form
    onSubmit={onContinue}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <Content>
          {({ InformativePageDescription = '', continueText }) => (
            <>
              <StandardBody>
                <p>{InformativePageDescription}</p>
              </StandardBody>
              <NavigationButton.Primary labelText={continueText} onClick={onContinue} />
            </>
          )}
        </Content>
      </form>
    )}
  />
);

export { InformativePage };
